import { Component, OnInit } from "@angular/core";
import { RentalFormComponent } from "../rental-form/rental-form.component";
import { LandlordService } from "src/app/services/landlord.service";
import { RentalService } from "src/app/services/rental.service";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { FormGroup } from "@angular/forms";
import { ImageUploadService } from "src/app/services/image-upload.service";
import { Rental } from "src/app/models/rental.model";
import { CommonModule } from "@angular/common";

@Component({
  standalone: true,
  imports: [CommonModule, RentalFormComponent],
  template: `
    <ng-container *ngIf="rental">
      <app-rental-form
        [rental]="rental"
        (save)="update($event)"
        (cancel)="back()">
      </app-rental-form>
    </ng-container>
  `
})
export class EditRentalComponent {
  rental!: Rental;

  constructor(
    private route: ActivatedRoute,
    private rentalService: RentalService,
    private router: Router
  ) {
    const id = this.route.snapshot.paramMap.get('id')!;
    this.rentalService.getRentalById(id).subscribe(r => {
      if (!r) return this.back();
      this.rental = r;
    });
  }

  async update(data: any) {
    console.log("SAVE PAYLOAD", data);
    await this.rentalService.updateRental(this.rental.id!, {
      ...data,
      available: data.status === 'available'
    });
    this.router.navigate(['/admin/admin-rentals']);
  }

  back() {
    this.router.navigate(['/admin/admin-rentals']);
  }
}
